import { ProductGroup, Profession, Topic } from '../models/base.models';

export interface Tag {
  name: string;
  id: string;
  filter: { [key: string]: string[] };
}

export function combineTags(
  topics: Topic[] | undefined,
  product_groups: ProductGroup[] | undefined,
  professions: Profession[] | undefined
): Tag[] {
  let tags: Tag[] = [];

  if (topics) {
    const mappedTopics: Tag[] = topics.map((topic) => {
      return <Tag>{
        name: topic.name,
        id: topic.id,
        filter: { topic: [topic.id] },
      };
    });

    tags = [...mappedTopics];
  }

  if (product_groups) {
    const mappedProductGroups: Tag[] = product_groups.map((productGroup) => {
      return <Tag>{
        name: productGroup.name,
        id: productGroup.id,
        filter: { productGroup: [productGroup.id] },
      };
    });

    tags = [...tags, ...mappedProductGroups];
  }

  if (professions) {
    const mappedProfessions: Tag[] = professions.map((profession) => {
      return <Tag>{
        name: profession.name,
        id: profession.id,
        filter: { profession: [profession.id] },
      };
    });

    tags = [...tags, ...mappedProfessions];
  }

  return tags;
}
